import Vue from 'vue';

Vue.component('new-cancelled-order', () =>
    import(/* webpackChunkName: 'cancelled-order' */ './cancelled-order.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/new-cancelled-order/index.js